import { render, staticRenderFns } from "./PfsFieldHelp.vue?vue&type=template&id=40e8a33c&scoped=true&"
import script from "./PfsFieldHelp.vue?vue&type=script&lang=js&"
export * from "./PfsFieldHelp.vue?vue&type=script&lang=js&"
import style0 from "./PfsFieldHelp.vue?vue&type=style&index=0&id=40e8a33c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e8a33c",
  null
  
)

export default component.exports